export class Beneficiaries{
    constructor(
        public OfferID?: Number,
        public Name?: String,
        public JMBG?: String,
        public Description?: String,
        public RoleID?: Number,
        public RoleName?: String,
        public InsureeID?: Number
        ){}
}